import { render, staticRenderFns } from "./ModelTableFactor.vue?vue&type=template&id=4407f41a&scoped=true&"
import script from "./ModelTableFactor.vue?vue&type=script&lang=ts&"
export * from "./ModelTableFactor.vue?vue&type=script&lang=ts&"
import style0 from "./ModelTableFactor.vue?vue&type=style&index=0&id=4407f41a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4407f41a",
  null
  
)

export default component.exports